import api from './api';

export const habilitacionService = {
    // Habilitaciones
    solicitarHabilitacion: async (data) => {
        const response = await api.post('/habilitaciones/solicitar', data);
        return response.data;
    },

    listarPendientes: async (usuario_id) => {
        const response = await api.get(`/habilitaciones/pendientes?usuario_id=${usuario_id}`);
        return response.data;
    },

    aceptarHabilitacion: async (id, usuario_receptor_id) => {
        const response = await api.post(`/habilitaciones/aceptar/${id}`, { usuario_receptor_id });
        return response.data;
    },

    // Notificaciones
    listarNotificaciones: async (usuario_id) => {
        const response = await api.get(`/notificaciones?usuario_id=${usuario_id}`);
        return response.data;
    },

    marcarLeidas: async (usuario_id) => {
        const response = await api.post('/notificaciones/marcar-leidas', { usuario_id });
        return response.data;
    }
};
